import React from 'react';
import PropTypes from 'prop-types';

import ImageDropzone from '../image_dropzone';

class PhotoUploader extends React.Component {
  static propTypes = {
    allowUpload: PropTypes.func,
    forwardedRef: PropTypes.any,
    uploadCopy: PropTypes.string,
    validFileFormats: PropTypes.string,
    onUpload: PropTypes.func.isRequired,
  }

  dropBox = (
    <div style={{ padding: '1em', border: '1px dashed #e1dede', cursor: 'pointer' }}>
      <h4 className="text-center dz-message">
        <i className="far fa-image text-muted pr-1"/>
        <span className="text-muted">
          {this.props.uploadCopy || 'Drag files, or click here to add files' }
        </span>
      </h4>
    </div>
  )

  render() {
    return (
      <div>
        <ImageDropzone
          accept={this.props.validFileFormats}
          allowUpload={this.props.allowUpload}
          disablePreview
          dropBox={this.dropBox}
          dropZoneClassName="media-uploader"
          forwardedRef={this.props.forwardedRef}
          onUploadComplete={this.props.onUpload}
        />
      </div>
    );
  }
}

export default PhotoUploader;
